export enum AssetDetailsTab {
  DETAILS = 'Details',
  ASSET_NOTE = 'Asset note',
  ASSET_STATUS_HISTORY = 'Asset status history',
}
